import { z } from 'zod';

export const shiftSchema = z.object({
  id: z.number(),
  ride: z.number(),
  status: z.string(),
  start_datetime: z.string(),
  end_datetime: z.string(),
  bus: z.number(),
  dispatch_provider: z.string(),
});

export type Shift = z.infer<typeof shiftSchema>;
